import React from 'react'
import { SvgIcon } from '@mui/material'

export const ToolBoxHeaderIcon = props => (
  <SvgIcon
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.33301 2.66732C1.33301 1.93094 1.92996 1.33398 2.66634 1.33398H5.99967C6.73605 1.33398 7.33301 1.93094 7.33301 2.66732V6.00065C7.33301 6.73703 6.73605 7.33398 5.99967 7.33398H1.33301V2.66732Z"
      fill="#818181"
    />
    <path
      d="M8.66699 2.66732C8.66699 1.93094 9.26395 1.33398 10.0003 1.33398H13.3337C14.07 1.33398 14.667 1.93094 14.667 2.66732V6.00065C14.667 6.73703 14.07 7.33398 13.3337 7.33398H8.66699V2.66732Z"
      fill="#305986"
      fillOpacity="0.3"
    />
    <path
      d="M8.66699 9.99935C8.66699 9.26297 9.26395 8.66602 10.0003 8.66602H13.3337C14.07 8.66602 14.667 9.26297 14.667 9.99935V13.3327C14.667 14.0691 14.07 14.666 13.3337 14.666H8.66699V9.99935Z"
      fill="#305986"
      fillOpacity="0.3"
    />
    <path
      d="M1.33301 9.99935C1.33301 9.26297 1.92996 8.66602 2.66634 8.66602H5.99967C6.73605 8.66602 7.33301 9.26297 7.33301 9.99935V13.3327C7.33301 14.0691 6.73605 14.666 5.99967 14.666H1.33301V9.99935Z"
      fill="#305986"
      fillOpacity="0.3"
    />
  </SvgIcon>
)
